import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import SearchableSelect from './SearchableSelect';
import { fetchAllPatientsBasicInfo } from '../services/api';

/*

OnSelect contract:

when an option is selected the onSelect callback
gets called with the patient object as its only arg
patient object:
{
  email,
  id,
  firstName,
  lastName,
  birthdate,
}

------------------------

onChange contract

optional callback for when user types into search bar, takes user's input as only arg

------------------------

customFilter contract:

optional sorting mechanism. sorts patient objects of form

{
  label: "firstName lastName (MM/DD/YYYY)",
  value: {
    email,
    id,
    firstName,
    lastName,
    birthdate,
  }
}

*/

function PatientSearchBar(props) {
  const {
    id = 7,
    disabled,
    onSelect,
    onChange,
    errorMessage,
    customFilter = null,
    label = 'For Patient',
    name = 'patient',
    placeholder = 'Search for a patient...',
    noOptionsMessage="No match found",
    maxOptions = 20,
    searchable = true,
    practiceId = 'currentUsersPracticeId',
    classes: { selectInput },
    searchClear,
  } = props;
  const [patients, setPatients] = useState([]);
  const [currentPatientId, setCurrentPatientId] = useState(null);
  

  // loading patient names
  // useEffect(() => {
  //   (async () => {
  //     let isMount = false;
  //     const patientList = await fetchAllPatientsBasicInfo(practiceId);
  //     if (isMount) {
  //       setPatients(
  //         patientList.map(p => ({
  //           label: `${p.firstName} ${p.lastName} (${moment
  //             .utc(p.birthdate)
  //             .format('MM/DD/YYYY')})`,
  //           value: p.id,
  //           info: p,
  //         }))
  //       );
  //     }
  //     return () => {
  //       isMount = true;
  //     };
  //   })();
  // }, []);
  useEffect(()=>{
    if(searchClear) {
      setCurrentPatientId(null);
      onSelect(null)
    }
  },[searchClear])


  // filtering patient names patient names appropriately when search bar is typed into
  const filterPatients = async patientName => {
    if (onChange) onChange(patientName);
    return patients
      .filter(
        customFilter ||
        ((patient, i) =>
          patient.label.toLowerCase().includes(patientName.toLowerCase()))
      )
      .slice(0, maxOptions);
  };

  const handleSelectionBeingMade = async patient => {
    if (patient) {
      setCurrentPatientId(patient.id);
      await onSelect(patient.info);
    } else {
      setCurrentPatientId(null)
      await onSelect(null)
    }
  };

  const getList = async(inputValue) =>{
    const patientList = await fetchAllPatientsBasicInfo(practiceId,inputValue);
    const data =  patientList.map(p => ({
        label: `${p.firstName} ${p.lastName} (${moment
          .utc(p.birthdate)
          .format('MM/DD/YYYY')})`,
        value: p.id,
        info: p,
      }))
      setPatients(data);
    return data
    .filter(
      customFilter ||
      ((patient, i) =>
        patient.label.toLowerCase().includes(inputValue.toLowerCase()))
    )
    .slice(0, maxOptions);
  }

  return (
    <SearchableSelect
      noOptionsMessage={noOptionsMessage}
      clearable
      disabled={disabled}
      searchable={searchable}
      fetchAsyncOptions={filterPatients}
      placeholder={placeholder}
      label={label}
      name={name}
      onChange={handleSelectionBeingMade}
      value={currentPatientId}
      options={[]}
      className={selectInput}
      error={!!errorMessage}
      errorMessages={errorMessage}
      getList={getList}
    />
  );
}

PatientSearchBar.propTypes = {
  id:PropTypes.string,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  customFilter: PropTypes.func,
  placeholder: PropTypes.string,
  practiceId: PropTypes.string,
  fullWidth: PropTypes.bool,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  name: PropTypes.string,
  maxOptions: PropTypes.number,
  searchable: PropTypes.bool,
  disabled: PropTypes.bool,
};

const styles = () => ({
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
});

export default withStyles(styles)(PatientSearchBar);

